import { csx } from '@vtex/admin-ui'

export const wrapper = csx({
  '.ant-drawer-header': {
    padding: '$space-6',
    border: 'none',
    '.ant-drawer-title': {
      fontSize: 'unset',
      fontWeight: 'unset',
    },
  },
  '.ant-drawer-footer': {
    padding: '$space-4 $space-6',
  },
  '.ant-drawer-body': {
    padding: '$space-0',
    height: '100%',
  },
})

export const footer = csx({
  gap: '$space-2',
})
